import { STORAGE_PREFIX } from './brand';

const DEVICE_ID_KEY = `${STORAGE_PREFIX}-device-id`;

/**
 * Stable anonymous identifier for this browser, used to auto-create a
 * server-side guest account so unauthenticated quiz activity can be
 * recorded and shown on the leaderboard. Lives in its own storage key so
 * it survives clearAuthStorage() on logout.
 */
export function getOrCreateDeviceId(): string {
  let id = localStorage.getItem(DEVICE_ID_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, id);
  }
  return id;
}
